import {Component} from '@angular/core';

@Component({
    selector: 'gbc-empty',
    template: '',
    standalone: true
})
export class EmptyComponent {}
